import { orderBy } from 'lodash'
import { useMemo } from 'react'
import { cn } from '~/@/lib/utils'
import { useGetDetailedWorkspaceQuery } from '~/common/generated/apollo-operations'
import { Breadcrumb } from '~/common/utils/breadcrumbs'
import { ViewLink } from './ViewLink'

type ProjectWorkspaceNavProps = {
  /** The root workspace whose views fill the sidebar; `id` is the root workspace id */
  project: {
    id: string
    name: string
  }
  expanded?: boolean
  breadcrumbs?: Breadcrumb[]
}

export const ProjectWorkspaceNav = ({ project, breadcrumbs }: ProjectWorkspaceNavProps) => {
  const { data: detailedWorkspace } = useGetDetailedWorkspaceQuery({
    variables: { workspaceId: project.id },
    skip: !project.id,
  })

  const orderedViews = useMemo(() => {
    return orderBy(detailedWorkspace?.workspace.views, (view) => view.order, ['asc'])
  }, [detailedWorkspace])

  if (!detailedWorkspace) {
    return null
  }

  return (
    <div
      className={cn(
        'relative before:bg-gray-1 flex w-full flex-col px-2 before:absolute before:start-0 before:top-0 before:h-2 before:w-full',
      )}
    >
      {!!orderedViews.length &&
        orderedViews.map((view) => (
          <ViewLink key={view.id} breadcrumbs={breadcrumbs} view={view} />
        ))}
    </div>
  )
}
